
import { get } from 'wtb-utils';

const url = process.env.REACT_APP_INVOICE_API_URL;
const pdfUrl = process.env.REACT_APP_INVOICE_PDF_API_URL;

function getInvoiceById(id) {
  return get(`${url}/${id}`);
}

function getInvoicePdf(id) {
  return get(`${pdfUrl}/${id}/json`);
}

export {
  getInvoiceById,
  getInvoicePdf
};
